// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import Storefront20 from './Storefront20';
import Storefront20Filled from './Storefront20Filled';
import Storefront20CircleFilled from './Storefront20CircleFilled';
import Storefront24 from './Storefront24';
import Storefront24Filled from './Storefront24Filled';
import Storefront24CircleFilled from './Storefront24CircleFilled';
import Storefront40 from './Storefront40';
import Storefront40Filled from './Storefront40Filled';
import Storefront48 from './Storefront48';
import Storefront48Filled from './Storefront48Filled';

type StorefrontProps = {
    variation:
        | '20'
        | '20Filled'
        | '20CircleFilled'
        | '24'
        | '24Filled'
        | '24CircleFilled'
        | '40'
        | '40Filled'
        | '48'
        | '48Filled';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    Storefront20,
    Storefront20Filled,
    Storefront20CircleFilled,
    Storefront24,
    Storefront24Filled,
    Storefront24CircleFilled,
    Storefront40,
    Storefront40Filled,
    Storefront48,
    Storefront48Filled,
};

const Storefront: FC<StorefrontProps> = ({ variation, ...props }) => {
    const variationKey = `Storefront${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"Storefront" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default Storefront;
